import { useCallback, useEffect, useMemo, useRef } from 'react'

export default function useShiftRangeSelection(visibleIds: number[]) {
  const lastSelectedIndex = useRef<number | null>(null)
  const visibleIdsKey = useMemo(() => visibleIds.join(','), [visibleIds])

  useEffect(() => {
    lastSelectedIndex.current = null
  }, [visibleIdsKey])

  const getSelectionIds = useCallback((id: number, shiftKey = false) => {
    const currentIndex = visibleIds.indexOf(id)
    const previousIndex = lastSelectedIndex.current

    if (currentIndex === -1) {
      return [id]
    }

    lastSelectedIndex.current = currentIndex

    if (!shiftKey || previousIndex === null || previousIndex < 0 || previousIndex >= visibleIds.length) {
      return [id]
    }

    const start = Math.min(previousIndex, currentIndex)
    const end = Math.max(previousIndex, currentIndex)

    return visibleIds.slice(start, end + 1)
  }, [visibleIds])

  const resetSelectionRange = useCallback(() => {
    lastSelectedIndex.current = null
  }, [])

  return {
    getSelectionIds,
    resetSelectionRange,
  }
}
